import { makeStyles } from '@material-ui/core/styles'
import { coachProfileTipSurface } from '@lib/pga-coach/coach-profile-layout'

const useStyles = makeStyles((theme) => ({
  root: {
    ...coachProfileTipSurface(theme),
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr)',
    alignItems: 'center',
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(2),
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      rowGap: theme.spacing(1.5),
      justifyItems: 'center',
      textAlign: 'center',
    },
  },
  logoWrapper: {
    display: 'flex',
  },
  /** Width follows the crest's own aspect ratio so no blank box pads the copy gap. */
  logo: {
    display: 'block',
    height: 48,
    width: 'auto',
    aspectRatio: '122 / 136',
  },
  copy: {
    minWidth: 0,
    flex: 1,
  },
  teaser: {
    color: theme.palette.secondary.dark,
    fontSize: '0.9375rem',
    lineHeight: 1.5,
  },
  /**
   * Inline with the classification sentence — same tertiary underline
   * as the bio clamp Read More, not a 48px filled CTA and not a
   * second block below the copy.
   */
  readMore: {
    appearance: 'none',
    background: 'transparent',
    border: 0,
    padding: 0,
    margin: 0,
    display: 'inline',
    color: theme.palette.blue.main,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 400,
    lineHeight: 'inherit',
    letterSpacing: 'normal',
    textTransform: 'none',
    textDecoration: 'underline',
    textUnderlineOffset: 3,
    cursor: 'pointer',
    '&:hover, &:focus-visible': {
      color: theme.palette.secondary.dark,
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: 2,
    },
  },
}))

export default useStyles
